/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const GraphPieIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Graph Pie',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M16 12.661V2.73a.515.515 0 0 0-.588-.507 15.952 15.952 0 0 0-8.384 4.163.511.511 0 0 0 .057.779l8.121 5.9a.5.5 0 0 0 .794-.404Zm4-9.932v30.542a.513.513 0 0 0 .587.506 15.986 15.986 0 0 0 0-31.555.513.513 0 0 0-.587.507ZM2 18a15.993 15.993 0 0 0 13.413 15.777.513.513 0 0 0 .587-.506V19.707a.5.5 0 0 0-.206-.4L4.31 10.959a.51.51 0 0 0-.756.184A15.872 15.872 0 0 0 2 18Z"
    />
  </svg>`;
};
